<template>
  <v-icon
    small
    :color="statusColor"
  >
    {{ statusIcon }}
  </v-icon>
</template>

<script>
  export default {
    props: {
      status: String,
    },
    data: () => ({
      byStatus: {
        facture_demandee: {
          icon: 'mdi-comment-alert',
          color: 'error',
        },
        facture_paiement_envoyee: {
          icon: 'mdi-comment-processing',
          color: 'info',
        },
        facture_acquittee_envoyee: {
          icon: 'mdi-comment-check',
          color: 'success',
        },
        __default: {
          icon: 'mdi-comment-outline',
          color: 'grey',
        },
      },
    }),
    computed: {
      statusColor () {
        if (this.byStatus[this.status]) {
          return this.byStatus[this.status].color
        }
        return this.byStatus.__default.color
      },
      statusIcon () {
        if (this.byStatus[this.status]) {
          return this.byStatus[this.status].icon
        }
        return this.byStatus.__default.icon
      },
    },
  }
</script>
